<template>
  <div class="delivery-form">
    <el-form size="small" :model="form" ref="deliveryForm" :rules="rules" label-position="top" v-loading="submitLoading">
      <div class="form-block">
        <h4 class="title">投放信息</h4>
        <el-divider class="divider"></el-divider>
        <div class="block-main">
          <el-form-item label="博主名称" prop="bloggerId" class="block-form-item w-25 select-input-wrap-s">
            <el-input :value="form.bloggerName && form.bloggerName" disabled>
              <i slot="append" class="iconfont icon-xialaxuanze_xialaduoxuan" @click="onOpenBloggerSelectModal"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="关联合同" prop="contractId" class="block-form-item w-25 select-input-wrap-s">
            <el-input :value="form.contractName && form.contractName" disabled>
              <i slot="append" class="iconfont icon-xialaxuanze_xialaduoxuan" @click="contractClick"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="客户名称" prop="customerName" class="block-form-item w-25">
            <el-input v-model="form.customerName" disabled></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName" class="block-form-item w-25">
            <el-input v-model="form.productName"></el-input>
          </el-form-item>
          <el-form-item label="品牌名称" prop="brandName" class="block-form-item w-25">
            <el-input v-model="form.brandName"></el-input>
          </el-form-item>
          <el-form-item label="投放负责人" prop="recordPrincipal" class="block-form-item w-25 select-input-wrap-s">
            <el-input :value="form.recordPrincipal && form.recordPrincipal" disabled>
              <i slot="append" class="iconfont icon-xialaxuanze_xialaduoxuan" @click="onOpenAdminSelectModal"></i>
            </el-input>
          </el-form-item>
        </div>
        <div class="bottom-divider"></div>
      </div>
      <div v-for="info in form.infos" :key="info.mediaId" class="form-block">
        <h4 class="title">发布形式{{info.index}}</h4>
        <el-divider class="divider"></el-divider>
        <el-form :model="info" ref="deliveryForm1" size="small" :rules="rules">
        <div class="block-main">
          <el-form-item label="账号平台" prop="mediaType"   class="block-form-item w-25" >
            <el-select v-model="info.mediaType" size="small" placeholder="未选择" class="w-100" @change="onChangeMediaType(info.index)" >
              <el-option v-for="(label, value) in mediaConfig.getConfigList('media_ch')" :key="value" :label="label" :value="parseInt(value)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资源" prop="mediaId"  class="block-form-item w-25 select-input-wrap-s">
            <el-input :value="info.bloggerName && info.bloggerName" disabled>
              <i  slot="append" class="iconfont icon-xialaxuanze_xialaduoxuan" @click="onOpenMediaSelectModal(info.index)"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="发布形式" prop="publishType" class="block-form-item w-25">
            <el-input v-model="info.publishType"></el-input>
          </el-form-item>
          <el-form-item label="发布日期" prop="publishTime"  class="block-form-item w-25">
            <el-date-picker v-model="info.publishTime" type="date" value-format="yyyy-MM-dd 00:00:00" class="w-100">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="执行价" prop="executePrice"  class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center" slot="label">
              执行价
              <el-tooltip class="item" effect="light" content="单个博主合作总价" placement="top">
                <i class="iconfont icon-tishi" style="color: #303133; margin-left: 10px; font-size: 12px"></i>
              </el-tooltip>
            </div>
            <el-input v-model="info.executePrice"></el-input>
          </el-form-item>
          <el-form-item label="投放链接" prop="publishUrl" class="block-form-item w-25">
            <el-input v-model="info.publishUrl"></el-input>
          </el-form-item>
          <el-form-item label="平台公司" prop="platfromCompanyId" class="block-form-item w-25">
            <el-select v-model="info.platfromCompanyId" class="w-100" >
              <el-option 
                v-for="(a, index) in platfromCompanyId" 
                :key="index" 
                :label="a.name" 
                :value="a.id"
                :disabled="!a.isEnable"
                >
                <div style="display: flex;padding:0 10px;justify-content: space-between;">
                  <div>{{a.name}}</div>
                  <div style="margin-left:15px;">{{a.isEnable?'':'已禁用'}}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="调整方式" prop="transMethod" class="block-form-item w-25">
            <el-select v-model="info.transMethod" clearable placeholder="未选择" class="w-100">
              <el-option label="增加" :value="0"></el-option>
              <el-option label="减少" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="调整金额" prop="transPrice" class="block-form-item w-25">
            <el-input v-model="info.transPrice"></el-input>
          </el-form-item>
          <el-form-item label="调整原因" prop="transRemark" class="block-form-item w-25">
            <el-input type="textarea" v-model="info.transRemark" rows="1" show-word-limit placeholder="请输入调整原因" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item class="block-form-item w-25">
            <el-button v-if="!info.displayTag" type="primary" size="mini" icon="el-icon-delete" @click="onShow(info.index)">显示全部</el-button>
            <el-button v-if="info.displayTag" type="primary" size="mini" icon="el-icon-delete" @click="onShow1(info.index)">隐藏</el-button>
          </el-form-item>
          <el-form-item class="block-form-item w-25">
            <el-button v-if="!info.displayTag" type="primary" size="mini" icon="el-icon-delete" @click="onDel(info.index)">删除</el-button>
          </el-form-item>
        </div>
        <div v-if="info.displayTag" class="block-main" >
          <el-form-item label="微任务" prop="wxjobPrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              微任务(元)
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="info.wxjobPrice"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="预设返点" prop="presetRebatePrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              预设返点(元)
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="info.presetRebatePrice"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="代下单费用" prop="agentOrderPrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              代下单费用(元)
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="info.agentOrderPrice"></el-input>
            </div>
          </el-form-item>
          
          <el-form-item label="差旅费用" prop="travelPrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              差旅费用(元)
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="info.travelPrice"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="其他成本" prop="otherPrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              其他成本(元)
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="info.otherPrice"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="其他成本备注" prop="otherPriceRemark" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              其他成本备注
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="info.otherPriceRemark"></el-input>
            </div>
          </el-form-item>
          <el-form-item  class="block-form-item w-25">
            <el-button v-if="info.displayTag" type="primary" size="mini" icon="el-icon-delete" @click="onDel(info.index)">删除</el-button>
          </el-form-item>
          
        </div>
        </el-form>
      </div>
      <div>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="onAdd">新增发布形式</el-button>
      </div> 
      
      <div class="form-block-submit" v-if="operateType !== 'show'">
        <el-button type="primary" size="small" @click="onSubmit" :disabled="submitLoading">提交</el-button>
      </div>
    </el-form>

    <el-dialog title="添加博主" :visible.sync="bloggerListModal" width="1000px" class="yhg-dialog" @open="openBloggerSelectModal">
      <div class="select-con single">
        <span class="label">已选账号：</span>
        <div class="content" v-if="selectBlogger">
          <el-tag class="select-tag" closable :type="selectBlogger.name" effect="dark" @close="onBloggerTagClose">
            <span class="select-tag-text">{{ selectBlogger.name }}</span>
          </el-tag>
        </div>
      </div>
      <div class="filter-con">
        <span class="label">账号搜索：</span>
        <el-input size="small" v-model="bloggerForm.queryString" placeholder="博主名称" @keyup.enter.native="onBloggerSearch"></el-input>
        <el-button class="search-btn" size="small" type="primary" @click="onBloggerSearch">搜索</el-button>
      </div>
      <div class="table-con">
        <el-table :data="bloggerTable" v-loading="bloggerTableLoading" size="mini" ref="bloggerSelectTable">
          <el-table-column label="选择" width="55" align="center">
            <template slot-scope="scope">
              <span class="hide-label-radio">
                <el-radio v-model="selectBloggerId" @change="onChangeBlogger" :label="scope.row.id"></el-radio>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="博主名称" prop="name" align="center" min-width="140"></el-table-column>
          <el-table-column label="博主类型" prop="bloggerType" align="center" min-width="140"></el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination background @size-change="bloggerSizeChange" @current-change="bloggerCurrentChange" :current-page.sync="bloggerPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="bloggerPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="bloggerPage.total">
          </el-pagination>
        </div>
      </div>
      <div class="submit-con">
        <el-button type="primary" size="small" @click="onConfirmBloggerChoose">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加资源" :visible.sync="mediaListModal" width="1000px" class="yhg-dialog" @open="openMediaSelectModal">
      <div class="select-con single">
        <span class="label">已选账号：</span>
        <div class="content" v-if="selectMedia">
          <el-tag class="select-tag" closable :type="selectMedia.name" effect="dark" @close="onMediaTagClose">
            <span class="select-tag-text">{{ selectMedia.name }}</span>
          </el-tag>
        </div>
      </div>
      <div class="filter-con">
        <span class="label">账号搜索：</span>
        <el-input size="small" v-model="mediaForm.queryString" placeholder="账号名称/ID/链接" @keyup.enter.native="onMediaSearch"></el-input>
        <el-button class="search-btn" size="small" type="primary" @click="onMediaSearch">搜索</el-button>
      </div>
      <div class="table-con">
        <el-table :data="mediaTable" v-loading="mediaTableLoading" size="mini" ref="mediaSelectTable">
          <el-table-column label="选择" width="55" align="center">
            <template slot-scope="scope">
              <span class="hide-label-radio">
                <el-radio v-model="selectMediaId" @change="onChangeMedia" :label="scope.row.mediaId"></el-radio>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="账号名称" prop="name" align="center" min-width="80"></el-table-column>
          <el-table-column label="平台" prop="mediaType" align="center" min-width="60">
            <template slot-scope="scope">
              {{ mediaConfig.getAppointed("media_ch", scope.row.mediaType, "") }}
            </template>
          </el-table-column>
          <el-table-column label="粉丝数" prop="fansNum" align="center" min-width="140"></el-table-column>
          <el-table-column label="账号ID/链接" prop="url" min-width="160"></el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination background @size-change="mediaSizeChange" @current-change="mediaCurrentChange" :current-page.sync="mediaPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="mediaPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="mediaPage.total">
          </el-pagination>
        </div>
      </div>
      <div class="submit-con">
        <el-button type="primary" size="small" @click="onConfirmMediaChoose">确认</el-button>
      </div>
    </el-dialog>
    <!-- 关联框架合同 -->
    <contractFramework ref="contractFramework" :contractValue="contractValue" @customChooseSave="customChooseSave" :contractDialog="contractDialog" @contractClose="contractClose"></contractFramework>
    <!-- 业务负责人 -->
    <el-dialog title="选择业务负责人" :visible.sync="adminListModal" width="1000px" class="yhg-dialog" @open="openAdminSelectModal">
      <div class="select-con single">
        <span class="label">已选人员：</span>
        <div class="content" v-if="selectAdmin">
          <el-tag v-if="selectAdmin.username" class="select-tag" closable :type="selectAdmin.username" effect="dark" @close="onAdminTagClose">
            <span class="select-tag-text">{{ selectAdmin.username }}</span>
          </el-tag>
        </div>
      </div>
      <div class="filter-con">
        <span class="label">用户搜索：</span>
        <el-input size="small" v-model="adminForm.queryString" placeholder="用户名/手机号" @keyup.enter.native="onAdminSearch"></el-input>
        <el-button class="search-btn" size="small" type="primary" @click="onAdminSearch">搜索</el-button>
      </div>
      <div class="table-con">
        <el-table :data="adminTable" v-loading="adminTableLoading" size="mini" ref="adminSelectTable">
          <el-table-column label="选择" width="55" align="center">
            <template slot-scope="scope">
              <span class="hide-label-radio">
                <el-radio v-model="selectAdminId" @change="onChangeAdmin" :label="scope.row.id"></el-radio>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="用户名" prop="username" align="center"></el-table-column>
          <el-table-column label="角色" prop="roleNameList" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.roleNameList">
                <div v-for="(item, index) in scope.row.roleNameList" :key="index">
                  {{ item }}
                </div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="phone" align="center">
            <template slot-scope="scope">
              {{ scope.row.phone ? scope.row.phone : "--" }}
            </template>
          </el-table-column>
          <el-table-column label="邮箱" prop="email">
            <template slot-scope="scope">
              {{ scope.row.email ? scope.row.email : "--" }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination background @size-change="adminSizeChange" @current-change="adminCurrentChange" :current-page.sync="adminPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="adminPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="adminPage.total">
          </el-pagination>
        </div>
      </div>
      <div class="submit-con">
        <el-button type="primary" size="small" @click="onConfirmAdminChoose">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import validate from "@/util/validate";
import { mediaConfig } from "@/const/config/media";
import { contractConfig } from "@/const/config/contract";
import { listAdmin } from "@/api/business/contract";
import { deliveryConfig } from "@/const/config/delivery";
import { billingConfig,billingShow } from "@/const/config/billing";
import deliveryFormFields from "@/const/form/deliveryFormFieldsNew";
import {
  detailDelivery,
  listMedia,
  listBlogger,
  listMediaContract,
  addDelivery,
  addDeliveryBatch,
  editDelivery
} from "@/api/business/delivery";
import { loginApi } from "@/api/login";
import { mapGetters } from "vuex";
import contractFramework from "@/components/common/contractFramework";
export default {
  components: {
    contractFramework
  },
  props: ["operateType"],
  data() {
    var validPrice = (rule, value, callback) => {
      if (!validate.checkNull(value)) {
        let err = validate.checkMoney(value, 100000000);
        if (err) {
          callback(new Error(err));
        }
        callback();
      }
      callback();
    };
    

    return {
       billingShow,
       billingConfig ,
      mediaConfig: mediaConfig,
      deliveryConfig: deliveryConfig,

      form: {
        mediaType: null, //账号/博主平台
        mediaId: null, //账号
        bloggerId:null,//博主ID
        bloggerName: null, //账号博主名称
        contractId: null, //关联合同
        recordPrincipal: "", //投放负责人
        recordPrincipalId: "", //投放负责人id
        contractName:"",
        customerName: "", //客户名称
        avatar: "", //客户头像
        brandName: "", //品牌名称
        productName: "", //产品名称
        publishType: "", //发布形式
        publishTime: "", //发布日期
        executePrice: "", //执行价格
        publishUrl: "", //投放链接
        settleStatus: 0, //结算状态
        settlePrice: "", //结算金额
        settleTime: "", //结算时间
        receiptPart: "", //收款方
        receiptTime: "", //收款时间
        shareIncome: "", //分成基数金额
        bloggerOtherCost: "", //博主其他成本
        finalRebate:"",//最终返点
        fixedRebate:"",//固定返点
        externalPlatform:"",//外部平台
        externalPlatformTaskId:"",//外部平台ID
        isRebateConfirmed:false,//返点是否已确认
        platfromCompanyId: "", //平台公司ID
        otherCost:0 ,
        wxjobPrice:0 ,
        presetRebatePrice:0 ,
        agentOrderPrice:0 ,
        otherPrice:0 ,
        travelPrice:0 ,
        otherPriceRemark:"",
        transMethod:"",
        transPrice:"",
        transRemark:"",
        index:1,
        infos:[{
          index:1,
          mediaType: null, //账号/博主平台
          mediaId: null, //账号/博主id
          publishType: "", //发布形式
          publishTime: "", //发布日期
          executePrice: "", //执行价格
          publishUrl: "", //投放链接
          platfromCompanyId: 8, //平台公司ID
          otherCost:0 ,
          wxjobPrice:0 ,
          presetRebatePrice:0 ,
          agentOrderPrice:0 ,
          otherPrice:0 ,
          travelPrice:0 ,
          otherPriceRemark:"",
          transMethod:"",
          transPrice:"",
          transRemark:"",
          displayTag:false,
        }],

      },


      /**
       * 投放负责人模块
       */
      adminListModal: false,
      adminPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      adminForm: {
        queryString: "",
      },
      selectAdminId: null,
      selectAdmin: null,
      adminTable: [],
      adminTableLoading: false,

      rules: {
        bloggerId: [
          { required: true, message: "请选择博主名称", trigger: "change" },
        ],
        executePrice: [{ validator: validPrice, trigger: "blur" },
                       { required: true, message: "请填写执行价", trigger: "blur" }],
        customerName: [
          { required: true, message: "请选择客户名称", trigger: "change" },
        ],
        contractId: [
          { required: true, message: "请选择关联合同", trigger: "change" },
        ],
        recordPrincipal: [
          { required: true, message: "请选择投放负责人", trigger: "change" },
        ],
        productName: [
          { required: true, message: "请填写产品名称", trigger: "change" },
        ],
        brandName: [
          { required: true, message: "请填写品牌名称", trigger: "change" },
        ],
        mediaType: [
          { required: true, message: "请选择账号平台", trigger: "change" },
        ],
        mediaId: [
          { required: true, message: "请选择资源", trigger: "change" },
        ],
        publishTime: [
          { required: true, message: "请选择发布日期", trigger: "blur" },
        ],
        platfromCompanyId: [
          { required: true, message: "请选择平台公司", trigger: "change" },
        ],
      },

      submitLoading: false,
      bloggerListModal: false,
      bloggerPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      bloggerForm: {
        queryString: "",
      },
      selectBloggerId: null,
      selectBlogger: null,
      bloggerTable: [],
      bloggerTableLoading: false,
      mediaListModal: false,
      mediaPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      mediaForm: {
        queryString: "",
      },
      selectMediaId: null,
      selectMediaType: null,
      selectMediaIndex: null,
      selectMedia: null,
      mediaTable: [],
      mediaTableLoading: false,

      contractDialog:false,
      contractValue:{} ,
      //平台公司
      platfromCompanyId:[{id:1,name:"薯一薯二文化传媒（上海）有限公司",isEnable: true},
      {id:2,name:"武汉巨量星图科技有限公司",isEnable: true},
      {id:3,name:"超电（上海）信息科技有限公司 ",isEnable: true},
      {id:4,name:"腾讯科技（深圳）有限公司",isEnable: true},
      {id:5,name:"宁波布谷鸟广告传媒有限公司",isEnable: true},
      {id:6,name:"天下秀广告有限公司",isEnable: true},
      {id:7,name:"广西耀远信息科技有限公司",isEnable: true},
      {id:8,name:"非商务运营平台开票合作",isEnable: true},
      {id:9,name:"天下秀科技有限公司",isEnable: true},
      {id:10,name:"武汉星图新视界科技有限公司",isEnable: true},
      {id:11,name:"薯鸿文化传媒（上海）有限公司",isEnable: true},
      ],
    };
  },
  created() {
      this.getUserInfo();
      this.form.infos[0].publishTime = this.getNowTime() ;
  },
  mounted() {},
  methods: {
    //关联合同确认
    customChooseSave(val){
      if(val){
        this.form.contractId = val.id
        this.form.contractName = val.name;
        this.form.customerName = val.customerName;
        this.form.brandName = val.brandName;
        this.form.productName = val.productName;
      }else{
        this.form.contractId = ""
        this.form.contractName = ""
        this.form.customerName =""
        this.form.brandName = ""
        this.form.productName = ""
      }
      
      this.contractDialog = false;
    },
    //关联合同
    contractClick(){
      this.contractValue = {
        id:this.form.contractId,
        name:this.form.contractName
      }
      this.$refs.contractFramework.customForm.bloggerId = this.form.bloggerId;
      this.contractDialog = true;
    },
    contractClose(){
      this.contractDialog = false;
    },
    //打开资源选择弹窗
    onOpenMediaSelectModal(infoIndex) {
      console.log(this.form);
      if (!this.form.bloggerId) {
        this.$message.warning("请选择博主！");
        return;
      }
      var index = this.form.infos.findIndex(item => {
        if ( item.index == infoIndex) {
          if(!item.mediaType){
            return;
          }else{
            if(item.mediaId){
              this.selectMediaId = item.mediaId ;
              this.selectMedia = {
                mediaId : item.mediaId ,
                name : item.bloggerName ,
              } ;
              this.selectMediaType = item.mediaType ;
              this.selectMediaIndex = infoIndex ;
            }else{
              this.selectMedia = null ;
              this.selectMediaId = null;
              this.selectMediaType = item.mediaType ;
              this.selectMediaIndex = infoIndex ;
            }
          }
          return true;
        }
        })
      if(index == '-1'){
        this.$message.warning("请选择账号平台！");
        this.selectMediaIndex = null ;
        return;
      }
      this.mediaListModal = true;
    },
    //资源选择弹窗打开
    openMediaSelectModal() {
      this.mediaForm.queryString = "";
      this.onMediaSearch();
    },
    //资源平台切换
    onChangeMediaType(infoIndex) {
      if(this.form.bloggerId){
        var bloggerName = "" ;
      var index = this.form.infos.findIndex(item => {
        if ( item.index == infoIndex) {
          let obj = {
            pageSize: this.mediaPage.pageSize,
            pageNum: this.mediaPage.pageNum,
          };
          obj.mediaType = item.mediaType ;
          obj.bloggerId = this.form.bloggerId ;
          listMedia(obj)
            .then((res) => {
              if(res.data.length>0){
                item.mediaId = res.data[0].mediaId ;
                item.bloggerName = res.data[0].name ;
                bloggerName = res.data[0].name ;
              }else{
                item.mediaId = "" ;
                item.bloggerName  = "" ;
              }
              
              console.log(this.form.infos);
            })
            .catch((err) => {
            });
            return true;
        }
        });
      }else{
        this.$message.warning("请选择博主！");
        var index = this.form.infos.findIndex(item => {
        if ( item.index == infoIndex) {
            item.mediaType = "" ;
            return true;
        }
        });
        return;
      }
      
        
    },
    //资源选择变化
    onChangeMedia(val) {
      this.selectMedia = this.mediaTable.find((v) => v.mediaId == val);
    },
    //资源标签删除
    onMediaTagClose() {
      this.selectMedia = null;
      this.selectMediaId = null;
    },
    //资源弹窗关闭
    onConfirmMediaChoose() {
      var infoIndex = this.selectMediaIndex ;
      var index = this.form.infos.findIndex(item => {
        if ( item.index == infoIndex) {
          if (this.selectMedia) {
            item.bloggerName = this.selectMedia.name ;
            item.mediaId = this.selectMedia.mediaId;
            item.avatar = this.selectMedia.avatar;
          }else{
            item.bloggerName = "" ;
            item.mediaId = "";
            item.avatar = null;
          }
          return true;
        }
        })
      this.mediaListModal = false;
      this.selectMediaIndex = null ;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    mediaSizeChange(val) {
      this.mediaPage.pageNum = 1;
      this.mediaPage.pageSize = val;
      this.getMediaList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    mediaCurrentChange(val) {
      this.mediaPage.pageNum = val;
      this.getMediaList();
    },
    //资源搜索
    onMediaSearch() {
      this.mediaPage.pageNum = 1;
      this.getMediaList();
    },
    //获取资源列表
    getMediaList() {
      let obj = {
        pageSize: this.mediaPage.pageSize,
        pageNum: this.mediaPage.pageNum,
      };
      obj.mediaType = this.selectMediaType ;
      obj.bloggerId = this.form.bloggerId ;
      if (this.mediaForm.queryString && this.mediaForm.queryString.trim()) {
        obj.queryString = this.mediaForm.queryString.trim();
      }
      this.mediaTableLoading = true;
      listMedia(obj)
        .then((res) => {
          this.mediaTable = res.data || [];
          this.mediaPage.total = res.total;
          this.mediaTableLoading = false;
        })
        .catch((err) => {
          this.mediaTable = [];
          this.mediaPage.total = 0;
          this.mediaTableLoading = false;
        });
    },


    getUserInfo() {
      loginApi.getUser().then((res) => {
        if (res.data) {
          console.log(res) ;
          this.form.recordPrincipal = res.data.user.username ;
          this.form.recordPrincipalId = res.data.user.id ;
        }
        console.log(this.form.recordPrincipalId);
      });
    },


    

    //提交
    onSubmit() {
      console.log(this.form) ;
      let errorList = [];
      //验证表单;
      this.$refs.deliveryForm.validate((valid, obj) => {
        if (valid) {
          // 联系人必填处理
          for (let i = 0; i < this.form.infos.length; i++) {
            if(!this.form.infos[i].mediaType || !this.form.infos[i].mediaId || !this.form.infos[i].publishTime || !this.form.infos[i].executePrice || !this.form.infos[i].platfromCompanyId){
              this.$message.warning('请输入完整的发布形式'+this.form.infos[i].index+'信息！');
              return;
            }
          }
          this.toSubmit();
        } else {
          this.$message.error(
            "表单不完整！请检查" +
              Object.keys(obj)
                .map((v) => "“" + deliveryFormFields.list[v] + "”")
                .join("、") +
              "是否按要求填写"
          );
        }
        console.log(errorList);
      });
    },
    //数据赋值
    toSubmit() {

      this.deliveryAdd(this.form);
    },
    //新增
    deliveryAdd(form) {
      this.submitLoading = true;
      addDeliveryBatch(form)
        .then((res) => {
          this.submitLoading = false;
          this.$message.success("新增投放成功");
          this.$emit("toDeliveryList");
        })
        .catch((err) => {
          this.submitLoading = false;
        });
    },


    //添加发布形式
    onAdd() {
      this.form.index = this.form.index + 1 ;
      this.form.infos.push({
          index:this.form.index,
          mediaType: null, //账号/博主平台
          mediaId: null, //账号/博主id
          publishType: "", //发布形式
          publishTime: this.getNowTime(), //发布日期
          executePrice: "", //执行价格
          publishUrl: "", //投放链接
          platfromCompanyId: 8, //平台公司ID
          otherCost:0 ,
          wxjobPrice:0 ,
          presetRebatePrice:0 ,
          agentOrderPrice:0 ,
          otherPrice:0 ,
          travelPrice:0 ,
          otherPriceRemark:"",
          transMethod:"",
          transPrice:"",
          transRemark:"",
          displayTag:false ,
        });
    },

    onDel(infoIndex) {

      var index = this.form.infos.findIndex(item => {
        if ( item.index == infoIndex) {
            return true;
        }
        })
      this.form.infos.splice(index,1);
    },


    onShow(infoIndex) {
      console.log(this.form.infos);
      var index = this.form.infos.findIndex(item => {
        if ( item.index == infoIndex) {
            item.displayTag = true ;
            console.log(item);
            return true;
        }
        })
    },

    onShow1(infoIndex) {
      console.log(this.form.infos);

      var index = this.form.infos.findIndex(item => {
        if ( item.index == infoIndex) {
            item.displayTag = false ;
            console.log(item);
            return true;
        }
        })
    },

    /**
     * 业务负责人模块
     */
    //打开资源选择弹窗
    onOpenAdminSelectModal() {
      this.adminListModal = true;
    },
    //资源选择弹窗打开
    openAdminSelectModal() {
      this.adminListModal = true;
      this.onAdminSearch();
    },
    //资源标签删除
    onAdminTagClose() {
      this.selectAdmin = null;
      this.selectAdminId = null;
    },
    //资源弹窗关闭
    onConfirmAdminChoose() {
      if (this.selectAdmin) {
        this.form.recordPrincipalId = this.selectAdmin.id;
        this.form.recordPrincipal = this.selectAdmin.username;
      } else {
        this.form.recordPrincipal = "";
        this.form.recordPrincipalId = null;
      }
      this.adminListModal = false;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    adminSizeChange(val) {
      this.adminPage.pageNum = 1;
      this.adminPage.pageSize = val;
      this.getAdminList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    adminCurrentChange(val) {
      this.adminPage.pageNum = val;
      this.getAdminList();
    },
    //资源搜索
    onAdminSearch() {
      this.adminPage.pageNum = 1;
      this.getAdminList();
    },
    //获取资源列表
    getAdminList() {
      let obj = {
        pageSize: this.adminPage.pageSize,
        pageNum: this.adminPage.pageNum,
        usernameOrPhone:this.adminForm.queryString
      };
      this.adminTableLoading = true;
      listAdmin(obj)
        .then((res) => {
          this.adminTable = res.data || [];
          this.adminPage.total = res.total;
          this.adminTableLoading = false;
        })
        .catch((err) => {
          this.adminTable = [];
          this.adminPage.total = 0;
          this.adminTableLoading = false;
        });
    },
    //资源选择变化
    onChangeAdmin(val) {
      console.log('====val====',val)
      this.selectAdmin = this.adminTable.find((v) => v.id == val);
    },

    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date} 00:00:00`;
      var time = defaultDate.toString;
      return defaultDate;
    },

    //打开博主资源弹唱
    onOpenBloggerSelectModal() {
      this.bloggerListModal = true;
    },
    //资源选择弹窗打开
    openBloggerSelectModal() {
      if (this.form.bloggerId) {
        this.selectBlogger = {
          id: this.form.bloggerId,
          name: this.form.bloggerName,
        };
        this.selectBloggerId = this.selectBlogger.id;
      } else {
        this.selectBlogger = null;
        this.selectBloggerId = null;
      }
      this.bloggerForm.queryString = "";
      this.onBloggerSearch();
    },
    //资源选择变化
    onChangeBlogger(val) {
      this.selectBlogger = this.bloggerTable.find((v) => v.id == val);
    },
    //资源标签删除
    onBloggerTagClose() {
      this.selectBlogger = null;
      this.selectBloggerId = null;
    },
    //资源弹窗关闭
    onConfirmBloggerChoose() {
      if (this.selectBlogger) {
        this.form.bloggerName = this.selectBlogger.name;
        this.form.bloggerId = this.selectBlogger.id;
      } else {
        this.form.bloggerName = "";
        this.form.bloggerId = null;
      }
      this.bloggerListModal = false;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    bloggerSizeChange(val) {
      this.bloggerPage.pageNum = 1;
      this.bloggerPage.pageSize = val;
      this.getBloggerList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    bloggerCurrentChange(val) {
      this.bloggerPage.pageNum = val;
      this.getBloggerList();
    },
    //资源搜索
    onBloggerSearch() {
      this.bloggerPage.pageNum = 1;
      this.getBloggerList();
    },
    //获取资源列表
    getBloggerList() {
      let obj = {
        pageSize: this.bloggerPage.pageSize,
        pageNum: this.bloggerPage.pageNum,
      };
      if (this.bloggerForm.queryString && this.bloggerForm.queryString.trim()) {
        obj.queryString = this.bloggerForm.queryString.trim();
      }
      this.bloggerTableLoading = true;
      listBlogger(obj)
        .then((res) => {
          this.bloggerTable = res.data || [];
          this.bloggerPage.total = res.total;
          this.bloggerTableLoading = false;
        })
        .catch((err) => {
          this.bloggerTable = [];
          this.bloggerPage.total = 0;
          this.bloggerTableLoading = false;
        });
    },
    


  },
  watch: {
    operateType(newVal, oldVal) {},

  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
};
</script>

<style lang="scss" scoped>
.form-block {
  position: relative;
  padding-bottom: 20px;

  .bottom-divider {
    position: absolute;
    left: -15px;
    right: -15px;
    bottom: 0;
    height: 10px;
    background: #f0f2f5;
    box-shadow: 0 2px 12px 0 rgb(220, 222, 226) inset;
  }

  .title {
    margin: 5px 0;
    font-size: 14px;
  }
  .divider {
    margin: 8px 0 10px;
  }

  &-submit {
    padding-top: 15px;
    text-align: center;
  }

  .block-form-item {
    &.w-25 {
      display: inline-block;
      width: 24%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-50 {
      display: inline-block;
      width: 49%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-99 {
      width: 99%;
      margin-right: 1%;
    }
  }
}

.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &.single {
      align-items: center;
      .select-tag {
        margin-bottom: 0;
      }
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
/deep/.select-con {
  .el-tag .el-icon-close {
    top: -2px;
  }
}
</style>

<style lang="scss">
.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 32px;
    height: 32px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      left: -1px;
      font-size: 33px !important;
    }
    cursor: pointer;
  }
}
.avue-view .cost-table {
  width: calc(50% + 100px);
  th {
    background: none;
    font-weight: normal;
    font-size: 14px;
  }
  .cell {
    padding-left: 0;
  }
}
.el-table .operate-column {
  vertical-align: text-top;
}
</style>
